var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0218 0H8.97818C4.01967 0 0 4.01967 0 8.97818V31.0218C0 35.9803 4.01967 40 8.97818 40H31.0218C35.9803 40 40 35.9803 40 31.0218V8.97818C40 4.01967 35.9803 0 31.0218 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0842 16.626H15.2408V30.0379H11.0842V16.626ZM13.2041 9.96167C13.6803 9.96168 14.1458 10.1027 14.542 10.367C14.9381 10.6313 15.2471 11.007 15.43 11.4467C15.6129 11.8864 15.6614 12.3705 15.5695 12.8377C15.4776 13.305 15.2494 13.7346 14.9136 14.0723C14.5778 14.41 14.1496 14.6407 13.6828 14.7353C13.2161 14.8298 12.7318 14.7841 12.291 14.6037C11.8503 14.4234 11.4728 14.1165 11.2063 13.7219C10.9397 13.3273 10.796 12.8625 10.7933 12.3863C10.7914 12.0686 10.8524 11.7536 10.9728 11.4595C11.0931 11.1654 11.2704 10.898 11.4944 10.6727C11.7185 10.4473 11.9849 10.2685 12.2783 10.1465C12.5717 10.0245 12.8863 9.96166 13.2041 9.96167Z",
    fill: "#68A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9011 16.6262H21.9052V18.455C22.306 17.771 22.8851 17.2086 23.5805 16.828C24.276 16.4473 25.0617 16.2626 25.854 16.2936C30.0105 16.2936 30.8557 19.0647 30.8557 22.6809V30.038H26.6991V23.5538C26.6991 22.002 26.6991 19.993 24.5377 19.993C22.3763 19.993 22.0438 21.6833 22.0438 23.4291V30.0657H17.8872L17.9011 16.6262Z",
    fill: "#68A678"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFooter);
export default __webpack_public_path__ + "static/media/LinkedinFooter.24c15dfa1557d63ccbafe657bdbad301.svg";
export { ForwardRef as ReactComponent };